import { ENUM_NullableBool } from '@api-new/common';
import { HTTP_AP_ListLenders_ForTable_Request_Filter, HTTP_AP_ListLenders_ForTable_Request_Sort } from '@api-new/mortgageservice';
import { RowDefinitionTypeEnum } from '@shared/components/table/enums/row-definition-type.enum';
import { BinaryStatusTableColumnModel } from '@shared/components/table/models/binary-status-table-column.model';
import { TableRowDefinitionModel } from '@shared/components/table/models/table-row-definition.model';

export interface LenderTableRowModel {
  id: string;
  name: string;
  logo: string;
  updatedAt?: string;
  isProvidedByDefaqto?: boolean;
  isCurrentlyOfferingMortgages: BinaryStatusTableColumnModel;
}

export const lenderTableFilterDefaults: HTTP_AP_ListLenders_ForTable_Request_Filter = {
  isProvidedByDefaqto: ENUM_NullableBool.NULLABLE_BOOL_UNSPECIFIED,
  name: '',
  isCurrentlyOfferingMortgages: ENUM_NullableBool.NULLABLE_BOOL_UNSPECIFIED,
};

export const lenderTableRowDefinition: TableRowDefinitionModel<LenderTableRowModel, HTTP_AP_ListLenders_ForTable_Request_Sort>[] = [
  {
    columnLabel: 'name',
    columnKey: 'name',
    type: RowDefinitionTypeEnum.Text,
    sortKey: 'byName',
    width: {
      min: '240px',
      max: '240px',
    },
    isFrozen: true,
  },
  {
    columnLabel: 'Logo',
    columnKey: 'logo',
    type: RowDefinitionTypeEnum.Image,
    width: {
      min: '150px',
      max: '150px',
    },
  },
  {
    columnLabel: 'id',
    columnKey: 'id',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '100px',
      max: '100px',
    },
  },
  {
    columnLabel: 'defaqto',
    columnKey: 'isProvidedByDefaqto',
    type: RowDefinitionTypeEnum.Boolean,
    width: {
      min: '80px',
      max: '80px',
    },
  },
  {
    columnLabel: 'Active lender',
    columnKey: 'isCurrentlyOfferingMortgages',
    type: RowDefinitionTypeEnum.BinaryStatus,
    width: {
      min: '120px',
      max: '120px',
    },
  },
  {
    columnLabel: 'last update',
    columnKey: 'updatedAt',
    type: RowDefinitionTypeEnum.Date,
    width: {
      min: '120px',
      max: '120px',
    },
  },
];
